import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import LandApp from "./components/App/MainPage/LandApp";
import { HowItWorks } from "./components/App/HowItWorks/HowItWorks/HowItWorks";
import { WorkSteps } from "./components/App/HowItWorks/Steps/WorkSteps";
import { Faq } from "./components/App/Faq/Faq";
import Apply from "./components/App/Apply/Apply";
import MainLayout from "./Layout/MainLayout";
import EmptyLayout from "./Layout/EmptyLayout";
import ContactUs from "./components/App/Contact/ContactUs";
import Terms from "./components/App/MainPage/Footer/Terms";
import Policy from "./components/App/MainPage/Footer/Policy";
import Blog from "./components/App/Blog";
import Article from "./components/App/Blog/Article";
import DefaultSEO from "./seo/DefaultSEO";


export default function App() {
  return (
    <HelmetProvider>
      <Router>
        <DefaultSEO /> 
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/" element={<LandApp />} />
            <Route
              path="/how-it-works"
              element={
                <>
                  <HowItWorks />
                  <WorkSteps />
                </>
              }
            />
            <Route path="/faq" element={<Faq />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/terms-of-service" element={<Terms />} />
            <Route path="/privacy-policy" element={<Policy />} />
            <Route path="/article/:slug" element={<Article />} />
          </Route>
          <Route element={<EmptyLayout />}>
            <Route path="/apply" element={<Apply />} />
          </Route>
        </Routes>
      </Router>
    </HelmetProvider>
  );
}
